import { UserActionDispatchTypes } from "../constants/User";
import { UserDispatchTypes } from "../models/DispatchTypes/User";
import { User } from "../models/User";

export interface SearchUserResponse {
  totalRows: number;
  searchResponse: User[];
}

export interface UserState {
  userData: {
    response: SearchUserResponse | null;
    loading: boolean;
  };
}

const initialState: UserState = {
  userData: {
    response: null,
    loading: false,
  },
};

const userReducer = (
  state: UserState = initialState,
  action: UserDispatchTypes
): UserState => {
  switch (action.type) {
    case UserActionDispatchTypes.GET_USERS_INVOKE:
      return {
        ...state,
        userData: {
          ...state.userData,
          loading: true,
        },
      };

    case UserActionDispatchTypes.GET_USERS_SUCCESS:
      return {
        ...state,
        userData: {
          response: action.response,
          loading: false,
        },
      };

    case UserActionDispatchTypes.GET_USERS_FAILURE:
      return {
        ...state,
        userData: {
          ...state.userData,
          loading: false,
        },
      };
  
    case UserActionDispatchTypes.GET_USERS_RESET: {
      return initialState;
    }

    default:
      return state;
  }
};

export default userReducer;